export default "__VITE_ASSET__DRArb$s8__"